import React from 'react';
import { IconType } from 'react-icons';

import {
    FaHome,
    FaUsers,
    FaBuilding,
    FaMapMarkedAlt,
    FaRoad,
    FaCogs,
    FaBell
} from 'react-icons/fa';
import {
    MdApartment,
    MdSubscriptions,
    MdSupportAgent,
    MdAssignment
} from 'react-icons/md';

// Page Imports
import Dashboard from '../pages/Dashboard';
import UserProperties from '../pages/Property/UserProperties';
import AllProperties from '../pages/Property/AllProperties';
import LoginPage from '../pages/LoginPage';
import Users from '../pages/Users';
import PropertyTypes from '../pages/PropertyTypes/PropertyTypes';
import ValuarProperies from '../pages/Property/ValuarProiperties';
import SubscriptionManagement from '../pages/SubscriptionManagement';
import Requests from '../pages/Requests';
import AreaManagement from '../pages/AreaManagement';
import AddUser from '../pages/Users/AddUser/AddUser';
import AddPropertyForSale from '../pages/Property/UserProperties/AddPropertyForSale/AddPropertyForSale';
import AddProperty from '../pages/Property/AllProperties/AddProperty/AddProperty';
import StreetManagement from '../pages/StreetManagement';
import AgentSearches from '../pages/Property/AgentSearches';
import ConstructionMasterDashboard from '../pages/Master/ConstructionMasterDashboard/ConstructionMasterDashboard';
import AgentInteractions from '../pages/AgentInteractions';
import ConstructionServicesAdmin from '../pages/Master/ConstructionServicesAdmin/ConstructionServicesAdmin';
import SendNotification from '../pages/SendNotification/SendNotification';
import TermsAndConditions from '../pages/TermsAndConditions/TermsAndConditions';
import PrivacyPolicy from '../pages/PrivacyPolicy/PrivacyPolicy';

export interface RouteConfig {
    path?: string;
    component?: React.ComponentType;
    label?: string;
    icon?: IconType;
    subRoutes?: RouteConfig[];
}

// 🚨 STRICT PUBLIC ROUTES (Guests only - redirects to '/' if logged in)
export const publicRoutes: RouteConfig[] = [
    { path: '/login', component: LoginPage },
];

// 🚨 UNIVERSAL ROUTES (Accessible to EVERYONE, whether logged in or not)
export const universalRoutes: RouteConfig[] = [
    { path: '/terms-and-conditions', component: TermsAndConditions },
    { path: '/privacy-policy', component: PrivacyPolicy },
];

export const privateRoutes: RouteConfig[] = [
    {
        path: '/',
        component: Dashboard,
        label: "Dashboard",
        icon: FaHome,
    },
    {
        label: 'Properties',
        icon: FaBuilding,
        subRoutes: [
            { path: '/all-properties', label: 'All Properties', component: AllProperties },
            { path: '/properties-for-sale', label: 'Properties For Sale', component: UserProperties },
            { path: '/valuer-properties', label: 'Valuer Properties', component: ValuarProperies },
            { path: '/agent-search', label: 'Agent Searches', component: AgentSearches },
        ],
    },
    {
        path: '/property-types',
        component: PropertyTypes,
        label: "Property Types",
        icon: MdApartment,
    },
    {
        path: '/requests',
        component: Requests,
        label: "Requests",
        icon: MdAssignment, 
    },
    {
        path: '/users',
        component: Users,
        label: "Users",
        icon: FaUsers,
    },
    {
        path: '/subscription-management',
        component: SubscriptionManagement,
        label: "Subscription",
        icon: MdSubscriptions,
    },
    {
        path: '/area-management',
        component: AreaManagement,
        label: "Area Management",
        icon: FaMapMarkedAlt, 
    },
    {
        path: '/street-management',
        component: StreetManagement,
        label: "Street Management",
        icon: FaRoad, 
    },
    {
        path: '/agent-interactions',
        component: AgentInteractions,
        label: "Agent Interactions",
        icon: MdSupportAgent, 
    },
    {
        label: 'Master',
        icon: FaCogs, 
        subRoutes: [
            { path: '/construction-master-dashboard', label: 'Construction Master', component: ConstructionMasterDashboard },
            { path: '/construction-services', label: 'Construction Services', component: ConstructionServicesAdmin },
        ],
    },
    {
        path: '/notification-center',
        component: SendNotification,
        label: "Notification Center",
        icon: FaBell, 
    },
];

export const additionalPrivateRoutes: RouteConfig[] = [
    {
        path: "/users/add",
        component: AddUser,
    },
    {
        path: "/users/edit/:id",
        component: AddUser,
    },
    {
        path: "/Properties-for-sale/add",
        component: AddPropertyForSale,
    },
    {
        path: "/Properties-for-sale/edit/:id",
        component: AddPropertyForSale,
    },
    {
        path: "/all-properties/add",
        component: AddProperty,
    },
    {
        path: "/all-properties/edit/:id",
        component: AddProperty,
    }
];